import script from "./POS.vue?vue&type=script&lang=ts&setup=true"
export * from "./POS.vue?vue&type=script&lang=ts&setup=true"

import "./POS.vue?vue&type=style&index=0&id=0df7bb30&lang=scss&scoped=true"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0df7bb30"]])

export default __exports__